import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import Preloader from '../Preloader';
import AIReport from './ai/AIReport';

const AIReportPage = ({ selectedClass, closeClass, user }) => {
  const [loading, setLoading] = useState(true);
  const [classDetails, setClassDetails] = useState(null);

  useEffect(() => {
    const fetchClass = async () => {
      setLoading(true);
      try {
        const snap = await getDoc(doc(db, 'classes', selectedClass.id));
        if (snap.exists()) {
          setClassDetails(snap.data());
        }
      } catch (err) {
        console.error('Error loading class:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchClass();
  }, [selectedClass.id]);

  if (loading) {
    return <Preloader />;
  }

  // If AI reporting is disabled for this class, show a fallback
  if (!classDetails?.aiReporting) {
    return (
      <div className="max-w-2xl mx-auto p-4">
        <button
          onClick={closeClass}
          className="mb-4 px-4 py-2 bg-[var(--primary-color)] text-white rounded-md hover:bg-[var(--hover-color)] transition-colors"
        >
          &larr; Back to Classes
        </button>
        <h2 className="text-2xl font-semibold text-[var(--text-color)]">
          {classDetails?.class_name || 'Class Name'}
        </h2>
        <p className="mt-2 text-[var(--muted-color)]">
          Professor has not enabled AI reporting access for this class.
        </p>
      </div>
    );
  }

  return (
    <div
      className="container mx-auto mt-4 px-4 py-4 rounded"
      style={{
        backgroundColor: 'var(--section-bg)',
        color: 'var(--text-color)',
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">
          {classDetails.class_name}
        </h2>
        <button
          onClick={closeClass}
          className="font-bold py-2 px-4 rounded transition-all duration-200"
          style={{
            backgroundColor: 'var(--primary-color)',
            color: 'var(--nav-active-text)',
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = 'var(--hover-color)')
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = 'var(--primary-color)')
          }
        >
          &times;
        </button>
      </div>

      {/* Single “AI Report” Tab */}
      <ul
        className="flex border-b mb-3"
        role="tablist"
        style={{ borderColor: 'var(--muted-color)' }}
      >
        <li>
          <button
            className="cursor-pointer py-2 px-4 transition-colors duration-200"
            style={{
              color: 'var(--primary-color)',
              borderBottom: '2px solid var(--primary-color)',
            }}
          >
            AI Report
          </button>
        </li>
      </ul>

      {/* AI Report Content */}
      <div className="mt-3">
        <AIReport classId={selectedClass.id} user={user} />
      </div>
    </div>
  );
};

export default AIReportPage;
